<template>
  <div style="overflow:hidden; height: 100vh !important;"
       class="justify-content-center align-items-center d-flex h-100 w-100" v-if="error">
    <div class="w-25 h-25"><img src="/assets/icon/ic_empty.svg" />
    </div>
  </div>
  <div v-else class="d-flex w-100">
    <ConversationList v-if="!app.switchCRM" @reloadConverastionPage="selectedConversation={}" ref="conversation"
                      :accounts="accounts"
                      @selected="selectConversation" />
    <div class="flex-grow-1">
      <div v-if="selectedConversation.id" class="d-flex">
        <div class="flex-1 conversation-center"
             v-bind:style="setWidth()">
          <GroupMessage :key="selectedConversation.accountId+selectedConversation.toId" ref="message"
                        :conversation="selectedConversation"
                        v-if="selectedConversation.group"
                        :showChat="showChat()"
                        @tagChanged="tagChanged"
          />
          <Message :key="selectedConversation.accountId+selectedConversation.toId" v-else
                   ref="message"
                   :conversation="selectedConversation"
                   :showChat="showChat()"
                   @tagChanged="tagChanged"
          />
        </div>
        <div v-if="!app.switchCRM && !app.expandMessage">
          <ConversationTab :key="selectedConversation.id" :conversation="selectedConversation"
                           v-if="selectedConversation.id" />
        </div>
      </div>
      <div v-else>
        <div v-if="!app.switchCRM">
        <ChangeVersion />

          <div class="d-flex justify-content-center w-100">
            <div style="margin:25vh 0px; ">
              <img src="/assets/images/dashboard.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { COMMON } from "../lib/Common";
import ConversationList from "../components/ConversationList";
import ConversationTab from "../components/ConversationTab";
import ChangeVersion from "../components/common/ChangeVersion.vue";

export default {
  components: {
    ChangeVersion,
    ConversationTab,
    ConversationList,
    Message: () => import("../components/Message"),
    GroupMessage: () => import("../components/GroupMessage.vue")
  },
  updated() {
  },
  data() {
    return {
      accounts: [],
      selectedConversation: {},
      error: false
    };
  },

  methods: {
    showChat() {
      let f = this.accounts.find(a => a.accountId == this.selectedConversation.accountId);
      if (f) {
        console.log(f);
        if (f.status == "ACTIVE") {
          return true;
        }
      }
      return false;
    },
    setWidth() {
      let width = 0;
      if (!this.app.switchCRM) {
        width += 360;
        if (!this.app.expandMessage) {
          width += 300;
        }
        if (this.app.navbarExpanded) {
          width += 160;
        }
      }
      let style = "max-width: calc(100vw - " + width + "px); min-width: calc(100vw - " + width + "px);";
      return style;
    },
    getConversation(id) {
      let arr = id.split("_");
      let accountId = arr[0];
      this.$http.get("/api/conversation/getOne", {
        params: {
          conversationId: id,
          accountId: accountId
        }
      }).then((resp) => {
        this.selectConversation(resp.data);
      }).catch(() => {
        this.error = true;
      });
    },

    getAccountList() {
      this.$http.get("/api/account/getAll").then(resp => {
        this.accounts = resp.data;
      });
    },
    unlockTyping(val) {
      if (val.length == 0) {
        this.sendTypingSocket("stopped_typing");
        this.typing = false;
      }
    },
    sendTypingSocket(type) {
      let request = {
        accountId: this.selectedConversation.accountId,
        conversationId: this.selectedConversation.id,
        type: type,
        username: this.app.user.swUsername
      };
      this.$http.post("/api/conversation/typing", request);
    },
    selectConversation(conversation) {
      if (this.selectedConversation.id && this.selectedConversation.id != conversation.id) {
        this.sendTypingSocket("stopped_typing");
      }
      this.app.selectedConversation = this.selectedConversation = conversation;
    },
    tagChanged(updatedConversation) {
      this.$refs.conversation.updateConversationTag(updatedConversation);
      this.$refs.conversation.updateConversationTagPin(updatedConversation);
    }
  },
  mounted() {
  },
  beforeDestroy() {
    this.$bus.$off("conversationUpdate");
    this.$bus.$off("conversationTyping");
    this.$bus.$off("conversation_tag");
    this.$bus.$off("hidden_conversation");
    this.$bus.$off("conversationRead");
    this.$bus.$off("messageUpdate");
    this.$bus.$off("updateGrMessage");
    this.$bus.$off("tagChanged");
  },
  created() {
    this.$bus.$on("conversationUpdate", data => {
      if (this.$refs.conversation) this.$refs.conversation.updateConversation(data);
      if (this.$refs.conversation) this.$refs.conversation.updateConversationPin(data);
    });
    this.$bus.$on("conversationTyping", data => {
      if (this.$refs.conversation) this.$refs.conversation.typingConversationPin(data);
      if (this.$refs.conversation) this.$refs.conversation.typingConversation(data);
    });
    this.$bus.$on("conversation_tag", data => {
      if (this.$refs.conversation) this.$refs.conversation.tagConversation(data);
    });
    this.$bus.$on("hidden_conversation", conversationId => {
      if (this.selectedConversation.id == conversationId) {
        this.selectedConversation = {};
      }
      if (this.$refs.conversation) this.$refs.conversation.hiddenConversation(conversationId);
    });
    this.$bus.$on("conversationRead", data => {
      if (this.$refs.conversation) this.$refs.conversation.readConversationPin(data);
      if (this.$refs.conversation) this.$refs.conversation.readConversation(data);
    });
    this.$bus.$on("updateGrMessage", data => {
      if (this.$refs.message) {
        this.$refs.message.addMessage(data);
      }
    });

    this.$bus.$on("messageUpdate", data => {
      if (this.$refs.message) {
        this.$refs.message.addMessage(data);
        if (data.id.conversationId == this.selectedConversation.id) {
          try {
            if (data.msgType === COMMON.CHAT_PHOTO || data.msgType === COMMON.CHAT_VIDEO) {
              this.$bus.$emit("updateImageOrVideoTab", data);
            } else if (data.msgType === COMMON.CHAT_FILE) {
              this.$bus.$emit("updateFileTab", data);
            }
          } catch (e) {
          //
          }
        }
      }
    });
    this.$bus.$on("tagChanged", data => {
      this.tagChanged(data);
    });

    if (this.app.switchCRM === true) {
      this.getConversation(this.app.conversationIdForCRM);
    }
    this.getAccountList();
  }
};
</script>

<style>
.conversation-center {
  max-width: calc(100vw - 660px);
  min-width: calc(100vw - 660px);
}
</style>
